
import { Component, ViewChild, TemplateRef, Pipe, PipeTransform, OnInit } from '@angular/core';
import { CertificadosService } from '../../../services/certificados.service';
//import { Tipos_certificados } from '../../../models/tipos_certificados.model';
import { Validators, FormControl, FormBuilder, FormGroup, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { controlNameBinding } from '@angular/forms/src/directives/reactive_directives/form_control_name';


@Component({
    selector: "page-tipos_certificados",
    templateUrl: "tipos_certificados.component.html",
    styleUrls: ["tipos_certificados.component.css"],
    providers: [FormService, CertificadosService]
})

export class Tipos_certificadosComponent implements OnInit {

    public identity;
    public token;
    @ViewChild('openModal') openModal: TemplateRef<any>;
    ///public tipos_certificados: Tipos_certificados;
    public rows = [];
    public actualRow;
    public matcher = new FormService();
    public tipos_cert = [];
    public results = [];
    public favCerts = [];
    public CertProp = [];
    public form;
    public Certchecked = [];
    public tiposCertError: Boolean = true;
    public propiedades;
    public checkeado
    public listaFinal = [];
    public certificados = []

    public listaRoles = [];

    constructor(private fb: FormBuilder, private dialog: MatDialog, private _certService: CertificadosService) {
        this.form = this.fb.group({
            tipos_cert: [],
            favCerts: [],

        })

        // this.CertProp = [{rol: '', id_direcc: '', folio: '', certificados: ''}]
        if (!JSON.parse(localStorage.getItem("tipos_certificados"))) {
            localStorage.setItem("tipos_certificados", JSON.stringify([]))
            localStorage.setItem("tipos_certificados", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("tipos_certificados"));
        }

    }

    ngOnInit() {

        this.get_tipos_cert();
        this.getCertificados();

    }

    addCertControls() {

        let arr = this.tipos_cert.map(item => {
            return this.fb.control(false);
        });

        return this.fb.array(arr);
    }

    get_tipos_cert() {
        if (JSON.parse(localStorage.getItem("propiedades")).length > 0) {
            this.propiedades = JSON.parse(localStorage.getItem("propiedades"));


        } else {
            localStorage.setItem("propiedades", JSON.stringify([]))
            this.propiedades = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', direc_anexo: '', direc_anexo_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', valido: '', recordId: '' }]
        }
    }
    get CertArray() {

        return <FormArray>this.form.favCerts;
    }

    addCertificado(propiedad, certificado){

        
        if(this.listaRoles.length == 0){
            this.listaRoles.push({
                rol: propiedad.rol,
                certificados: [certificado.cert_id]
            })
        }else{

            var roleExiste = false;
            var certificadoExiste = false;

            for(let i=0; i < this.listaRoles.length; i++){

                if(this.listaRoles[i].rol == propiedad.rol){
                    roleExiste = true;
                    certificadoExiste = false;

                    for(let x=0; x < this.listaRoles[i].certificados.length; x++ ){

                        if(this.listaRoles[i].certificados[x] == certificado.cert_id){
                            certificadoExiste = true;
                            this.listaRoles[i].certificados.splice(x,1);
                        }

                    }

                    if(!certificadoExiste){
                        this.listaRoles[i].certificados.push(certificado.cert_id)
                    }


                }
            }

            if(!roleExiste){
                this.listaRoles.push({
                    rol: propiedad.rol,
                    certificados: [certificado.cert_id]
                })
            }


        }
        localStorage.setItem("tipos_certificados", JSON.stringify(this.listaRoles));

    }


    getCertificados(){

             
            this._certService.getTipo_cert().subscribe(
                response => {
                    
                    this.listaFinal = response.lista

                },
                error => {
                    console.log(error)
                })
          
    }



    checkTouched() {
        let flg = false;
        this.CertArray.controls.forEach(control => {
            if (control.touched) {
                flg = true;
            }
        });
        return flg;
    }

    add_tipos_cert() {
        
        this.Certchecked = [];
        this.CertArray.controls.forEach((control, i) => {
            if (control.value) {
                this.Certchecked.push(this.tipos_cert[i]);
            }
        });

        this.tiposCertError = this.Certchecked.length > 0 ? false : true;


    }

    cleanData() {
        // this.tipos_certificados = {cod: '',tipo:'', cert_id: ''};
    }

    delete_tipos_certificados(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipos_certificados", JSON.stringify(this.rows));
            }
        }
    }

}